module.exports = __webpack_public_path__ + "static/media/TestTypeZero.29efb319.svg";